import React, { useState } from 'react';

import { addCustomer, editCustomer } from './api'
import '../styles/edit-form.scss';
import {
    TextField,
    Button,
    IconButton,
    FormHelperText
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { ChromePicker } from 'react-color';

export function CustomerEditForm(props) {
    const { setShowEditForm, customer, closeCallback } = props;
    const [bitrixCode, setBitrixCode] = useState(customer.bitrix_code ?? 0);
    const [name, setName] = useState(customer.name ?? '');
    const [color, setColor] = useState(customer.color??'');

    const addCustomerButtonClick = () => {
        !customer.id
            ? addCustomer({
                bitrix_code: bitrixCode,
                name: name,
                color: color
            })
            : editCustomer({
                id: customer.id,
                bitrix_code: bitrixCode,
                name: name,
                color: color
            })
        setShowEditForm(false);
        closeCallback();
    };

    const closeForm = () => {
        setShowEditForm(false);
    };

    return (
        <div className="edit-form">
            <div className='edit-form__window'>
                <TextField className='input' type="number" label="Код в битрикс" variant="standard" value={bitrixCode} onChange={(event) => { setBitrixCode(event.target.value) }} />
                <TextField className='input' label="Наименование" variant="standard" value={name} onChange={(event) => { setName(event.target.value) }} />
                <FormHelperText>Цвет</FormHelperText>
                <div style={{width: '100%', height:  30, background: color + 'b3', border: '1px solid ' + color, margin: '10px 0px'}}></div>
                <ChromePicker 
                    color={color}
                    onChangeComplete={(color) => setColor(color.hex)}
                    disableAlpha={true}
                />
                <Button variant="contained" id='submit-button' onClick={addCustomerButtonClick}>{customer.id ? 'Изменить' : 'Добавить'}</Button>
                <IconButton id='close-button' onClick={closeForm}>
                    <Close />
                </IconButton>
            </div>
        </div>
    );
}